import React from 'react';
import {Link} from 'react-router';
import ReactDataSheet from 'react-datasheet';
import FirebaseApi from '../../api/firebase'
import DatePicker from 'react-datepicker';
import moment from 'moment'
import {connect} from 'react-redux';




class TeacherPage extends React.Component {

	constructor (props) {

		super(props)
		this.state = {
			name: "",
			rut: "",
			start_date: moment().format('DD-MM-YYYY')
		}
	}


    componentWillMount = () => {

		if(this.props.teacherInfo.id != "") {
			console.log('mounting')
      		this.state = this.props.teacherInfo
		}
    }

    handleTeacherDateChange = (date) => {
      	this.setState({
        	start_date: date.format('DD-MM-YYYY')
      	})
    }

    handleNameInputChange = (event) => {
	      const target = event.target;
	      const value = target.type === 'checkbox' ? target.checked : target.value;
	      const id = target.id;

	      this.setState({
	          [id]: value
	      });
    }

    saveTeacher = () => {

		//IMPORTANT: Check that rut is not on DB before saving
		let teacher = this.state


		//Creating new teacher
		if(teacher.id == null) {
      		teacher['contracts'] = {}
			FirebaseApi.databasePush('/teachers', teacher).then( val => {
	        	this.props.history.push('/')

			})
		}
		//Updating
		else {
			let id = teacher.id
			teacher['id'] = null
			teacher['sign_date'] = null
		    FirebaseApi.databaseSet('/teachers/' + id, teacher).then( val => {
		    	this.props.history.push('/')
		    })


      //Update teacher name in his contracts
      Object.keys(teacher.contracts).forEach((school) => {
        Object.keys(teacher.contracts[school]).forEach((contract) => {
           FirebaseApi.databaseUpdate('/contracts/' + contract, {name: teacher.name})
        })
      })
		}


    }


	render() {
		return (

		<div className="jumbotron">
         	<div className='save-contract-button-container'>
            	<div className='save-contract-button'>
              		<button className='btn btn-success' onClick={() => this.saveTeacher()}>Guardar Profesor</button>
            	</div>
          	</div>
        	<h1>Nuevo Profesor</h1>
            <h3>Información</h3>
            <div className='information-container'>
                <div className='form-group w-50'>
                 	<label htmlFor='name'>Nombre</label>
                  	<input
		                type='text'
		                id='name'
		                className='form-control '
		                value={this.state.name}
		                onChange={this.handleNameInputChange}    ></input>
                	</div>
                <div className='form-group w-50'>
                 	<label htmlFor='rut'>Rut</label>
                  	<input
	                    type='text'
	                    id='rut'
	                    className='form-control '
	                    value={this.state.rut}
	                    onChange={this.handleNameInputChange}>
                  	</input>
                </div>
                <div className='form-group w-25'>
                 	<label htmlFor='startDate'>Fecha de Contrato</label>

                  	<DatePicker
		                selected={moment(this.state.start_date, 'DD-MM-YYYY')}
		                onChange={this.handleTeacherDateChange}
		                showYearDropdown
		                dateFormatCalendar="MMMM"
		                scrollableYearDropdown
		                minDate={moment('1-1-1992', 'DD-MM-YYYY')}
		                maxDate={moment()}
		                yearDropdownItemNumber={30}
		                dateFormat="DD/MM/YYYY"
		             />
                </div>
            </div>
        </div>
		)
	}
}

function mapStateToProps(state, ownProps) {
  return {
    teacherInfo:  JSON.parse(JSON.stringify(state.teacherInfo))
  }
}


export default connect(mapStateToProps,null)(TeacherPage);


// WEBPACK FOOTER //
// ./src/components/teacher/Teacher.js